import { createFileRoute, redirect } from "@tanstack/react-router";
import { RdwOverviewClient } from "@/features/resources/RdwOverviewClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Resources → Transportmiddelen → compared with the RDW (docs/tms-stamdata.md §7, S43).
// Taking data over is managing units: tms_resources_write (S34) — here, and on the API regardless.
export const Route = createFileRoute("/_shell/transport-units/rdw")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin") && !hasModule(context.session, "tms_resources_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: TransportUnitsRdwScreen,
});

function TransportUnitsRdwScreen() {
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Transport Units RDW">
      <RdwOverviewClient />
    </div>
  );
}
